
/* 
  Developed by: Jordyn Kao
  Contact: jordyninternational@gmail.com
  This component is part of the application and contains internal credits.
  This code is protected under the terms of the contract agreement.
  Unauthorized use or distribution of this code is prohibited.
*/
import { Building, Coins, TrendingUp, Globe, ArrowRight } from "lucide-react";
import { LinkButton } from "@/components/Button";

const AssetClassesSection = () => {
  const assetClasses = [
    {
      icon: Building,
      title: "Real estate",
      description: "Commercial and residential properties across South Africa's major economic hubs",
      allocation: "35%",
      examples: ["Sandton Office Parks", "Cape Town Residential", "Durban Industrial"]
    },
    {
      icon: Coins,
      title: "Private credit",
      description: "Direct lending to established South African businesses and emerging market opportunities",
      allocation: "30%",
      examples: ["SME Lending", "Trade Finance", "Infrastructure Debt"]
    },
    {
      icon: TrendingUp,
      title: "Private equity",
      description: "Growth capital for promising South African companies and regional expansion",
      allocation: "25%",
      examples: ["Tech Startups", "Healthcare", "Financial Services"]
    },
    {
      icon: Globe,
      title: "Commodities",
      description: "Exposure to South Africa's rich natural resources and commodity markets",
      allocation: "10%",
      examples: ["Gold Mining", "Platinum", "Agricultural Products"]
    }
  ];

  return (
        <section id="asset-classes" className="py-20 md:py-32 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            A Diversified Approach to Building Wealth
          </h2>
                    <p className="md:text-lg text-gray-600 max-w-3xl mx-auto">
            We provide access to a spectrum of carefully selected alternative assets, allowing you to build a truly diversified and resilient portfolio.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {assetClasses.map((asset, index) => (
                                    <div 
              key={index} 
              className="flex flex-col bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all duration-300 group border border-slate-300 hover:border-[hsl(var(--bronze-gold))]"
            >
              <div className="flex items-center justify-between mb-6">
                                                <div className="w-12 h-12 bg-[hsl(var(--navy))] rounded-lg flex items-center justify-center">
                  <asset.icon className="w-6 h-6 text-white" />
                </div>
                <div className="text-2xl font-bold text-[hsl(var(--bronze-gold))]">
                  {asset.allocation}
                </div>
              </div>
              
              <div className="flex-grow mb-6">
                                                <h3 className="text-xl font-bold text-gray-900 mb-3 transition-colors duration-300">
                  {asset.title}
                </h3>
                                                                <p className="text-slate-600 leading-relaxed">
                  {asset.description}
                </p>
              </div>
              
                                                                      <div className="border-t border-slate-300 pt-4 mt-auto">
                                                                <div className="text-sm font-semibold text-slate-800 mb-2">Key focus areas</div>
                {asset.examples.map((example, idx) => (
                                                                        <div key={idx} className="text-sm text-slate-600 flex items-center">
                    <div className="w-1.5 h-1.5 bg-[hsl(var(--bronze-gold))] rounded-full mr-2"></div>
                    {example}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <LinkButton 
            to="/investments"
            variant="solid"
            size="lg"
            className="group"
          >
            <span>Start Exploring Investments</span>
            <ArrowRight className="w-5 h-5 ml-2 transition-transform duration-300 group-hover:translate-x-1" />
          </LinkButton>
        </div>

      </div>
    </section>
  );
};

export default AssetClassesSection;
